import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { Modal } from "antd";
import NotificationService from "../../../Services/NotificationService";
import dayjs from "dayjs";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Preview from "../../../Assets/Images/Svg/PreviewIcon.svg";
import CommonFunctions from "../../Shared/CommonFunctions";
import { getNotificationCount } from "../../../Redux/actions/NotificationActions";
import { useDispatch } from "react-redux";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const getNotificationList = async (pageNo = 1, pageSize = 9) => {
    if (!loginResultObject) return;

    const payload = {
      account_Id: loginResultObject.user.account_Id,
      clinic_id: loginResultObject.user.clinic_Id,
      userId: loginResultObject.user.userId,
      status: 1,
      pageNo,
      pageSize,
    };

    const result = await NotificationService.NotificationList(payload);
    const allData = result.data[0]?.notificationList || [];
    setNotifications(allData);
    if (result.data[0]?.notificationList.length === payload.pageSize) {
      setHasMore(true);
    }

    if (result.data[0]?.notificationList.length === pageSize) {
      setTotalPages(pageNo + 1);
    } else {
      setTotalPages(pageNo);
    }

    setCurrentPage(pageNo);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      getNotificationList(page);
    }
  };

  useEffect(() => {
    getNotificationList();
  }, []);

  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const truncateContent = (content) => {
    const words = content?.split(" ");
    return words.length > 10 ? `${words.slice(0, 10).join(" ")} ...` : content;
  };

  const markAsRead = async (record) => {
    let payload = {
      id: record.id,
      countStatus: "Y",
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss",
      ),
    };
    try {
      let result = await NotificationService.NotificationUpdate(payload);
      setNotifications((prevNotifications) =>
        prevNotifications.map((notif) =>
          notif.id === record.id ? { ...notif, countStatus: "Y" } : notif,
        ),
      );
      let countStatus = await dispatch(getNotificationCount());
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layouts>
      <div className="md:text-2xl text-white text-xl tracking-wider font-medium mb-8">
        Notification
      </div>

      {/* Notification Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {notifications.map((record, index) => (
          <div
            key={index}
            onClick={(e) => {
              setIsModalOpen(true);
              setMessage(record);
              markAsRead(record);
            }}
            className={`rounded-lg shadow p-4 cursor-pointer hover:shadow-md transition-all ${
              record.countStatus === "N" ? "bg-blue-50" : "bg-white"
            }`}
          >
            <div className="text-sm text-gray-500 mb-2">
              {dayjs(record.date).format("DD/MM/YYYY")}
            </div>

            <div className="flex items-center justify-between mb-1">
              <div className="font-semibold text-lg">{record.subject}</div>
              {record.countStatus === "N" && (
                <span className="text-xs bg-blue-500 text-white rounded-full px-2 py-0.5">
                  New
                </span>
              )}
            </div>

            <div className="text-gray-700 text-sm mb-2">
              {truncateContent(record.content)}
            </div>
          </div>
        ))}
      </div>
      <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
        <div className="flex items-center justify-center space-x-2">
          <button
            className={`p-2 rounded-md ${
              currentPage === 1
                ? "text-gray-400 cursor-not-allowed bg-white"
                : "text-gray-700 bg-white"
            }`}
            onClick={() => goToPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <FaChevronLeft className="text-[#189FAA]" />
          </button>

          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;
            return (
              <button
                key={page}
                className={`px-3 py-1 rounded-md ${
                  currentPage === page
                    ? "bg-teal-500 text-white text-sm"
                    : "text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                }`}
                onClick={() => goToPage(page)}
              >
                {page}
              </button>
            );
          })}

          <button
            className={`p-2 rounded-md ${
              currentPage === totalPages
                ? "text-gray-400 cursor-not-allowed bg-white"
                : "text-gray-700 bg-white"
            }`}
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <FaChevronRight className="text-[#189FAA]" />
          </button>
        </div>
      </div>

      <Modal
        title={
          <div className="flex items-center border-b border-brand-colorBorder pb-4">
            <h3 className="mb-0 text-lg font-semibold tracking-wider ml-3">
              {dayjs(message.date).format("DD/MM/YYYY")}
            </h3>
          </div>
        }
        footer={[]}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="45%"
      >
        <div className="flex flex-col gap-2 ">
          <div className="font-bold">{message.subject} :</div>
          <div>{message.content}</div>
        </div>
      </Modal>
    </Layouts>
  );
}

export default Notification;
